import { render, staticRenderFns } from "./tag.vue?vue&type=template&id=d046a346&scoped=true"
import script from "./tag.vue?vue&type=script&lang=ts"
export * from "./tag.vue?vue&type=script&lang=ts"
import style0 from "./tag.less?vue&type=style&index=0&id=d046a346&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d046a346",
  null
  
)

export default component.exports